import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'main',
    component: () => import(/* webpackChunkName: "main" */ '../views/Main.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '../views/auth/Login.vue'),
    meta: {
      guest: true
    }
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import(/* webpackChunkName: "forgot-password" */ '../views/auth/ForgotPassword.vue'),
    meta: {
      guest: true
    }
  },
  {
    path: '/recover-account/:token',
    name: 'recover-account',
    component: () => import(/* webpackChunkName: "recover-account" */ '../views/auth/RecoverAccount.vue'),
    meta: {
      guest: true
    }
  },
  {
    path: '/activate-account/:token',
    name: 'activate-account',
    component: () => import(/* webpackChunkName: "activate-account" */ '../views/auth/ActivateAccount.vue'),
    meta: {
      guest: true
    }
  },
  {
    path: '/admin',
    component: () => import(/* webpackChunkName: "admin" */ '../views/Admin.vue'),
    children: [
      {
        path: '',
        name: 'admin',
        component: () => import(/* webpackChunkName: "admin" */ '../views/admin/Home.vue')
      },
      {
        path: 'members',
        component: () => import(/* webpackChunkName: "members" */ '../views/admin/Members.vue'),
        children: [
          {
            path: '',
            name: 'members',
            component: () => import(/* webpackChunkName: "members" */ '../views/admin/members/Index.vue')
          },
          {
            path: 'create',
            name: 'members.create',
            component: () => import(/* webpackChunkName: "members" */ '../views/admin/members/Create.vue')
          },
          {
            path: ':id',
            component: () => import(/* webpackChunkName: "members" */ '../views/admin/members/Show.vue'),
            children: [
              {
                path: '',
                name: 'members.show',
                component: () => import(/* webpackChunkName: "members" */ '../views/admin/members/show/Index.vue')
              },
              {
                path: 'contributions',
                component: () => import(/* webpackChunkName: "members" */ '../views/admin/members/show/Contributions.vue'),
                children: [
                  {
                    path: 'create',
                    name: 'members.contributions.create',
                    component: () => import(/* webpackChunkName: "members" */ '../views/admin/members/show/contributions/Create.vue')
                  },
                  {
                    path: ':cont_id',
                    name: 'members.contributions.show',
                    component: () => import(/* webpackChunkName: "members" */ '../views/admin/members/show/contributions/Show.vue')
                  },
                ]
              },
            ]
          },
          {
            path: ':id/edit',
            name: 'members.edit',
            component: () => import(/* webpackChunkName: "members" */ '../views/admin/members/Edit.vue')
          },
        ]
      },
      {
        path: 'contributions',
        component: () => import(/* webpackChunkName: "contributions" */ '../views/admin/Contributions.vue'),
        children: [
          {
            path: '',
            name: 'contributions',
            component: () => import(/* webpackChunkName: "contributions" */ '../views/admin/contributions/Index.vue')
          },
          {
            path: 'create',
            name: 'contributions.create',
            component: () => import(/* webpackChunkName: "contributions" */ '../views/admin/contributions/Create.vue')
          },
          {
            path: 'pending',
            name: 'contributions.pending',
            component: () => import(/* webpackChunkName: "contributions" */ '../views/admin/contributions/Pending.vue')
          },
          {
            path: ':id',
            name: 'contributions.show',
            component: () => import(/* webpackChunkName: "contributions" */ '../views/admin/contributions/Show.vue')
          },
        ]
      },
      {
        path: 'loans',
        component: () => import(/* webpackChunkName: "loans" */ '../views/admin/Loans.vue'),
        children: [
          {
            path: '',
            name: 'loans',
            component: () => import(/* webpackChunkName: "loans" */ '../views/admin/loans/Index.vue')
          },
          {
            path: ':id',
            component: () => import(/* webpackChunkName: "loans" */ '../views/admin/loans/Show.vue'),
            children: [
              {
                path: '',
                name: 'loans.show',
                component: () => import(/* webpackChunkName: "loans" */ '../views/admin/loans/payments/Index.vue')
              },
              {
                path: 'payments',
                name: 'loans.payments',
                component: () => import(/* webpackChunkName: "loans" */ '../views/admin/loans/payments/Create.vue')
              },
            ]
          },
        ]
      },
      {
        path: 'settings',
        component: () => import(/* webpackChunkName: "settings" */ '../views/admin/Settings.vue'),
        children: [
          {
            path: '',
            name: 'settings',
            component: () => import(/* webpackChunkName: "settings" */ '../views/admin/settings/Index.vue')
          },
          {
            path: 'contributions',
            component: () => import(/* webpackChunkName: "settings" */ '../views/admin/settings/Contributions.vue'),
            children: [
              {
                path: 'create',
                name: 'settings.contributions.create',
                component: () => import(/* webpackChunkName: "settings" */ '../views/admin/settings/contributions/Create.vue')
              },
              {
                path: ':id/edit',
                name: 'settings.contributions.edit',
                component: () => import(/* webpackChunkName: "settings" */ '../views/admin/settings/contributions/Edit.vue')
              },
            ]
          },
          {
            path: 'loans',
            component: () => import(/* webpackChunkName: "settings" */ '../views/admin/settings/Loans.vue'),
            children: [
              {
                path: 'create',
                name: 'settings.loans.create',
                component: () => import(/* webpackChunkName: "settings" */ '../views/admin/settings/loans/Create.vue')
              },
              {
                path: ':id',
                name: 'settings.loans.show',
                component: () => import(/* webpackChunkName: "settings" */ '../views/admin/settings/loans/Show.vue')
              },
              {
                path: ':id/edit',
                name: 'settings.loans.edit',
                component: () => import(/* webpackChunkName: "settings" */ '../views/admin/settings/loans/Edit.vue')
              },
            ]
          },
        ]
      },
      {
        path: 'loan-applications',
        component: () => import(/* webpackChunkName: "loan-applications" */ '../views/admin/LoanApplications.vue'),
        children: [
          {
            path: '',
            name: 'loan-applications',
            component: () => import(/* webpackChunkName: "loan-applications" */ '../views/admin/loan-applications/Index.vue')
          },
          {
            path: 'create',
            name: 'loan-applications.create',
            component: () => import(/* webpackChunkName: "loan-applications" */ '../views/admin/loan-applications/Create.vue')
          },
          {
            path: ':id',
            name: 'loan-applications.show',
            component: () => import(/* webpackChunkName: "loan-applications" */ '../views/admin/loan-applications/Show.vue')
          },
        ]
      },
      {
        path: 'loan-payments',
        component: () => import(/* webpackChunkName: "loan-payments" */ '../views/admin/LoanPayments.vue'),
        children: [
          {
            path: '',
            name: 'loan-payments',
            component: () => import(/* webpackChunkName: "loan-payments" */ '../views/admin/loan-payments/Index.vue')
          },
          {
            path: 'create',
            name: 'loan-payments.create',
            component: () => import(/* webpackChunkName: "loan-payments" */ '../views/admin/loan-payments/Create.vue')
          },
          {
            path: ':id',
            name: 'loan-payments.show',
            component: () => import(/* webpackChunkName: "loan-payments" */ '../views/admin/loan-payments/Show.vue')
          },
        ]
      },
      {
        path: 'contribution-payments',
        component: () => import(/* webpackChunkName: "contribution-payments" */ '../views/admin/ContributionPayments.vue'),
        children: [
          {
            path: '',
            name: 'contribution-payments',
            component: () => import(/* webpackChunkName: "contribution-payments" */ '../views/admin/contribution-payments/Index.vue')
          },
          {
            path: ':id',
            name: 'contribution-payments.show',
            component: () => import(/* webpackChunkName: "contribution-payments" */ '../views/admin/contribution-payments/Show.vue')
          },
        ]
      },
      {
        path: 'reports',
        component: () => import(/* webpackChunkName: "reports" */ '../views/admin/Reports.vue'),
        children: [
          {
            path: '',
            name: 'reports',
            component: () => import(/* webpackChunkName: "reports" */ '../views/admin/reports/Index.vue')
          },
          {
            path: 'contributions',
            name: 'reports.contributions',
            component: () => import(/* webpackChunkName: "reports" */ '../views/admin/reports/Contributions.vue')
          },
          {
            path: 'contribution-payments',
            name: 'reports.contribution-payments',
            component: () => import(/* webpackChunkName: "reports" */ '../views/admin/reports/ContributionPayments.vue')
          },
          {
            path: 'loans',
            name: 'reports.loans',
            component: () => import(/* webpackChunkName: "reports" */ '../views/admin/reports/Loans.vue')
          },
          {
            path: 'loan-payments',
            name: 'reports.loan-payments',
            component: () => import(/* webpackChunkName: "reports" */ '../views/admin/reports/LoanPayments.vue')
          },
          {
            path: 'expenses',
            name: 'reports.expenses',
            component: () => import(/* webpackChunkName: "reports" */ '../views/admin/reports/Expenses.vue')
          },
        ]
      },
      {
        path: 'expenses',
        component: () => import(/* webpackChunkName: "expenses" */ '../views/admin/Expenses.vue'),
        children: [
          {
            path: '',
            name: 'expenses',
            component: () => import(/* webpackChunkName: "expenses" */ '../views/admin/expenses/Index.vue')
          },
          {
            path: 'create',
            name: 'expenses.create',
            component: () => import(/* webpackChunkName: "expenses" */ '../views/admin/expenses/Create.vue')
          },
          {
            path: ':id',
            name: 'expenses.show',
            component: () => import(/* webpackChunkName: "expenses" */ '../views/admin/expenses/Show.vue')
          },
          {
            path: ':id/edit',
            name: 'expenses.edit',
            component: () => import(/* webpackChunkName: "expenses" */ '../views/admin/expenses/Edit.vue')
          },
        ]
      },
    ]
  },
  {
    path: '/*',
    name: '404',
    component: () => import(/* webpackChunkName: "404" */ '../views/404.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes
})

export default router
